jQuery(document).ready(function() {
	var formData = new FormData();
	jQuery(document).on('click', '.ct_product .ct_gift_btn', function() {
		var prod_title = jQuery(".title-row .title").text();
		var prod_id = __st.rid;

		clevertap.event.push("Gifting Option Clicked", {
			"Product title": prod_title,
			"Product ID": prod_id,
		});
		jQuery("body").addClass("ct_stop_scroll");
		jQuery(".mm-ajaxcart-close").trigger("click");
		jQuery('.ct_product .ct_design_Gift_Main').show();
		jQuery('.ct_product .ct_design_Gift_Main').addClass("active");
	})

	jQuery(document).on('click', '.ct_product .ct_close_gift, .CT_cart_save_box_close', function() {
		jQuery('.ct_product .ct_design_Gift_Main').hide();
		jQuery("body").removeClass("ct_stop_scroll");
		jQuery('.ct_product .ct_cart_design_Gift_Main').hide();
		jQuery('.ct_product .ct_design_Gift_Main').removeClass("active");
		jQuery('.ct_product .ct_cart_design_Gift_Main').removeClass("active");

		var video_src = jQuery(".ct_product .record_video").attr("src")
		var audio_src = jQuery(".ct_product .record_audio").attr("src")
		if (typeof video_src != "undefined") {
			$('.ct_product .record_video').get(0).pause();
		}
		if (typeof audio_src != "undefined") {
			$('.ct_product .record_audio').get(0).pause();
		}
	})


	var shop_url = "kushalsonline-com.myshopify.com";


	jQuery(document).on("click", ".ct_product .ct_return_video_wrap .ct_return_btn", function() {
		jQuery(".ct_product .ct_video_play_show").hide();
		jQuery(".ct_product .ct_video_record_video  .ct_audio_recorded").show();
		jQuery(".ct_product .ct_return_video_wrap").hide();
		jQuery(".ct_product #videoRecorded").hide();
		jQuery(".ct_product .record_video").attr("src", "");

		jQuery(".ct_product .ct_gift_tab.active .ct_tip_lable").show();
		jQuery(".ct_product .ct_gift_tab.active  .tab-content.active .ct_wrap_tips").show();

		var svg_notselected = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.8636 6.29216L12.0703 5.37049C11.9186 5.19549 11.7961 4.86883 11.7961 4.63549V3.64383C11.7961 3.02549 11.2886 2.51799 10.6703 2.51799H9.67863C9.45113 2.51799 9.11863 2.39549 8.94363 2.24383L8.02196 1.45049C7.61946 1.10633 6.96029 1.10633 6.55196 1.45049L5.63613 2.24966C5.46113 2.39549 5.12863 2.51799 4.90113 2.51799H3.89196C3.27363 2.51799 2.76613 3.02549 2.76613 3.64383V4.64133C2.76613 4.86883 2.64363 5.19549 2.49779 5.37049L1.71029 6.29799C1.37196 6.70049 1.37196 7.35383 1.71029 7.75633L2.49779 8.68383C2.64363 8.85883 2.76613 9.18549 2.76613 9.41299V10.4105C2.76613 11.0288 3.27363 11.5363 3.89196 11.5363H4.90113C5.12863 11.5363 5.46113 11.6588 5.63613 11.8105L6.55779 12.6038C6.96029 12.948 7.61946 12.948 8.02779 12.6038L8.94946 11.8105C9.12446 11.6588 9.45113 11.5363 9.68446 11.5363H10.6761C11.2945 11.5363 11.802 11.0288 11.802 10.4105V9.41883C11.802 9.19133 11.9245 8.85883 12.0761 8.68383L12.8695 7.76216C13.2078 7.35966 13.2078 6.69466 12.8636 6.29216ZM9.71363 5.92466L6.89613 8.74216C6.81446 8.82383 6.70363 8.87049 6.58696 8.87049C6.47029 8.87049 6.35946 8.82383 6.27779 8.74216L4.86613 7.33049C4.69696 7.16133 4.69696 6.88133 4.86613 6.71216C5.03529 6.54299 5.31529 6.54299 5.48446 6.71216L6.58696 7.81466L9.09529 5.30633C9.26446 5.13716 9.54446 5.13716 9.71363 5.30633C9.88279 5.47549 9.88279 5.75549 9.71363 5.92466Z" fill="#E6DD0A"></path> </svg>';
		jQuery(".accordion.active .ct_selected_value").html(" Not Selected " + svg_notselected);
		recordedChunks_video = [];
		jQuery(".accordion.active").parent().removeClass("ct_fill_active")

	})


	jQuery(document).on("click", ".ct_product .ct_again_audio", function() {
		jQuery("#audioFileInput").val("");

		jQuery(".ct_product .ct_gift_tab.active  .tab-content.active .ct_wrap_tips").show();
		jQuery(".ct_product .ct_gift_tab.active  .tab-content.active .ct_tip_lable").show();

		jQuery('.ct_product .tab-content.active .ct_audio_recorded').show();
		jQuery('.ct_product .ct_wrap_audio').hide();
		jQuery('.ct_product .record_audio source').attr("src", "");
		var svg_notselected = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.8636 6.29216L12.0703 5.37049C11.9186 5.19549 11.7961 4.86883 11.7961 4.63549V3.64383C11.7961 3.02549 11.2886 2.51799 10.6703 2.51799H9.67863C9.45113 2.51799 9.11863 2.39549 8.94363 2.24383L8.02196 1.45049C7.61946 1.10633 6.96029 1.10633 6.55196 1.45049L5.63613 2.24966C5.46113 2.39549 5.12863 2.51799 4.90113 2.51799H3.89196C3.27363 2.51799 2.76613 3.02549 2.76613 3.64383V4.64133C2.76613 4.86883 2.64363 5.19549 2.49779 5.37049L1.71029 6.29799C1.37196 6.70049 1.37196 7.35383 1.71029 7.75633L2.49779 8.68383C2.64363 8.85883 2.76613 9.18549 2.76613 9.41299V10.4105C2.76613 11.0288 3.27363 11.5363 3.89196 11.5363H4.90113C5.12863 11.5363 5.46113 11.6588 5.63613 11.8105L6.55779 12.6038C6.96029 12.948 7.61946 12.948 8.02779 12.6038L8.94946 11.8105C9.12446 11.6588 9.45113 11.5363 9.68446 11.5363H10.6761C11.2945 11.5363 11.802 11.0288 11.802 10.4105V9.41883C11.802 9.19133 11.9245 8.85883 12.0761 8.68383L12.8695 7.76216C13.2078 7.35966 13.2078 6.69466 12.8636 6.29216ZM9.71363 5.92466L6.89613 8.74216C6.81446 8.82383 6.70363 8.87049 6.58696 8.87049C6.47029 8.87049 6.35946 8.82383 6.27779 8.74216L4.86613 7.33049C4.69696 7.16133 4.69696 6.88133 4.86613 6.71216C5.03529 6.54299 5.31529 6.54299 5.48446 6.71216L6.58696 7.81466L9.09529 5.30633C9.26446 5.13716 9.54446 5.13716 9.71363 5.30633C9.88279 5.47549 9.88279 5.75549 9.71363 5.92466Z" fill="#E6DD0A"></path> </svg>';
		jQuery(".accordion.active .ct_selected_value").html(" Not Selected " + svg_notselected);
		jQuery(".accordion.active").parent().removeClass("ct_fill_active");
		jQuery('.ct_product .tab-content.active .ct_wrap_audio .record_audio').get(0).pause()

	})
	var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"/></svg>'

	jQuery(document).on("input", ".ct_gift_tab.active #ct_gif_msg", function() {
		var t = jQuery(this).val();
		var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"> <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path> </svg>'
		if (t.length > 0) {
			jQuery(".accordion.active .ct_selected_value").html(" Text added " + svg);
			jQuery(".accordion.active .ct_selected_value").show();
		} else {
			var svg_notselected = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.8636 6.29216L12.0703 5.37049C11.9186 5.19549 11.7961 4.86883 11.7961 4.63549V3.64383C11.7961 3.02549 11.2886 2.51799 10.6703 2.51799H9.67863C9.45113 2.51799 9.11863 2.39549 8.94363 2.24383L8.02196 1.45049C7.61946 1.10633 6.96029 1.10633 6.55196 1.45049L5.63613 2.24966C5.46113 2.39549 5.12863 2.51799 4.90113 2.51799H3.89196C3.27363 2.51799 2.76613 3.02549 2.76613 3.64383V4.64133C2.76613 4.86883 2.64363 5.19549 2.49779 5.37049L1.71029 6.29799C1.37196 6.70049 1.37196 7.35383 1.71029 7.75633L2.49779 8.68383C2.64363 8.85883 2.76613 9.18549 2.76613 9.41299V10.4105C2.76613 11.0288 3.27363 11.5363 3.89196 11.5363H4.90113C5.12863 11.5363 5.46113 11.6588 5.63613 11.8105L6.55779 12.6038C6.96029 12.948 7.61946 12.948 8.02779 12.6038L8.94946 11.8105C9.12446 11.6588 9.45113 11.5363 9.68446 11.5363H10.6761C11.2945 11.5363 11.802 11.0288 11.802 10.4105V9.41883C11.802 9.19133 11.9245 8.85883 12.0761 8.68383L12.8695 7.76216C13.2078 7.35966 13.2078 6.69466 12.8636 6.29216ZM9.71363 5.92466L6.89613 8.74216C6.81446 8.82383 6.70363 8.87049 6.58696 8.87049C6.47029 8.87049 6.35946 8.82383 6.27779 8.74216L4.86613 7.33049C4.69696 7.16133 4.69696 6.88133 4.86613 6.71216C5.03529 6.54299 5.31529 6.54299 5.48446 6.71216L6.58696 7.81466L9.09529 5.30633C9.26446 5.13716 9.54446 5.13716 9.71363 5.30633C9.88279 5.47549 9.88279 5.75549 9.71363 5.92466Z" fill="#E6DD0A"></path> </svg>';
			jQuery(".accordion.active .ct_selected_value").html(" Not Selected " + svg_notselected);
			//jQuery(".accordion.active .ct_selected_value").hide();
		}
	})



	$(document).on('click', '.ct_product .tab-link', function() {


		var tabID = $(this).attr('data-tab');
		console.log(tabID + " -- ");
		$(this).addClass('active').siblings().removeClass('active');

		$('.ct_product #tab-' + tabID).addClass('active').siblings().removeClass('active');

		var video_src = jQuery(".ct_product .record_video").attr("src")
		var audio_src = jQuery(".ct_product .record_audio").attr("src")
		if (typeof video_src != "undefined") {
			$('.ct_product .record_video').get(0).pause();
		}
		if (typeof audio_src != "undefined") {
			$('.ct_product .record_audio').get(0).pause();
		}
	});








	$(document).on('click', '.ct_product .ct_record_record', function() {
		jQuery(this).closest('.active').find('.ct_audio_recorded').toggleClass("ct_record_show");
	})

	$(document).on('click', '.ct_product .ct_video_record .ct_record_record', function() {
		jQuery(this).closest('.active').find('.ct_video_record_video').toggleClass("ct_video_record_show");
		jQuery(".ct_audio_recorded.ct_record_show").show();
	})

	jQuery(document).on("click", ".ct_product .ct_cart_edit", function() {
		jQuery('.ct_product .ct_design_Gift_Main').show();

		jQuery('.ct_product .ct_design_Gift_Main').addClass("active");
		jQuery('.ct_product .ct_cart_design_Gift_Main').addClass("active");
	})
	jQuery(document).on("input", ".ct_wrap_contact .ct_msg_name", function(e) {
		var value_no = jQuery(this).val();
		jQuery(".ct_wrap_contact .ct_msg_name").val(value_no);
	})
	// jQuery(".ct_wrap_contact .ct_msg_number").on('input',function(e){

	// })
	jQuery(document).on("input", ".ct_gift_tab.active .ct_msg_number", function(e) {

		var value = jQuery(this).val();
		jQuery(".ct_wrap_contact .ct_msg_number").val(value);

		$(this).val($(this).val().replace(/\D/g, '')); // Remove non-digit characters
		if ($(this).val().length > 10) {
			$(this).val($(this).val().slice(0, 10));
		}

		setTimeout(function() {

			var content = jQuery(".ct_wrap_contact .ct_msg_number").val()[0]

			console.log(content);
			// var entered = $(this).val(),
			//   content = parseInt(entered,10);    
			if (content <= 5) {
				jQuery(".ct_msg_number").addClass("ct_error");
				jQuery(".ct_no_error").show();
				return false;
			} else {
				jQuery(".ct_msg_number").removeClass("ct_error");
				jQuery(".ct_no_error").hide();
			}
		}, 100)
		var charCode = (e.which) ? e.which : event.keyCode;
		if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
			jQuery(".ct_no_error").hide();
			return false;
		}
	});

	$(document).on("keyup", "#ct_gif_msg", function() {
		var txt_length = $(this).val().length;
		if (txt_length <= 400) {

			$(".text_count").text(($(this).val().length) + " / 400");
		} else {
			$(".text_count").text("400 / 400");

		}
		if ($(this).val().length > 0) {
			jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", false);
		} else {
			jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", true);
		}
	});


	/**** Gifting 2.0 30-04-2024  ******/
	jQuery(document).on("click", ".ct_wrap_list .ct_tag_list", function() {
		jQuery(".ct_wrap_list .ct_tag_list").removeClass("ct_tag_active")
		var data_id = jQuery(this).attr("data-id");
		jQuery(this).addClass("ct_tag_active");
		jQuery(".tab-content .ct_inner_html").removeClass("ct_tag_active")
		jQuery(".tab-content .ct_inner_html").each(function() {
			var in_data_id = jQuery(this).attr('data-id')

			if (in_data_id == data_id) {
				jQuery(this).addClass("ct_tag_active");
			}
		})
	})


})

function openContactPicker() {
	const supported = "contacts" in navigator && "ContactsManager" in window;

	if (supported) {
		getContacts();
	} else {
		alert(
			"Contact list API not supported!. Only for android mobile chrome and chrome version > 80"
		);
	}
}
async function getContacts() {
	const props = ["name", "email", "tel"];
	const opts = {
		multiple: true
	};

	try {
		const contacts = await navigator.contacts.select(props, opts);
		// var json_encode=JSON.stringify(contacts);
		//  var con_data = jQuery.parseJSON(json_encode);
		// // var con_data = jQuery.parseJSON(con_data);
		// alert(contacts)
		// alert(contacts['tel']+" == "+contacts['name'])

		// Assuming contacts is an array of contact objects
		for (let i = 0; i < contacts.length; i++) {
			const contact = contacts[i];
			if (contact.name != "" && contact.tel != "") {
				jQuery(".ct_msg_name").val(contact.name)
				jQuery(".ct_msg_number").val(contact.tel)
			}

		}

		//alert(JSON.stringify(contacts));
	} catch (err) {
		alert(err);
	}
}